import React, { useCallback, useMemo } from "react";
import { Sparkles, Star } from "lucide-react";
import { useHistory } from "react-router-dom";
import { Constants, RoleConstants } from "../utils/constants";
import toastUtils from "../utils/toast";
import * as localService from "../services/localService";
import { FeatureAccess } from "../utils/featureAccessControl";
import { isOrgAdmin } from "../utils/orgAdminAccess";
import logger from "../utils/logger";


const HUpgradeButton = ({
  label = "Upgrade",
  to = "/host/pricing?view=packages",
  onClick,
  className = "",
  size = "md",
}) => {
  const history = useHistory();

  const userData = useMemo(() => localService.getUser(), []);

  const isAdminRole = useCallback(() => {
    return isOrgAdmin(userData);
  }, [userData]);

  if (!FeatureAccess.canUpgradePlan(userData)) return null;

  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "px-5 py-3 text-base",
  };

  const handleClick = event => {
    logger.log("kflkodo [HUpgradeButton] Button clicked");

    // Check if user role is allowed to upgrade
    if (!isAdminRole()) {
      logger.log("kflkodo [HUpgradeButton] NOT admin role, showing warning");
      toastUtils.warning("Contact Admin", {
        description: "Contact your admin to upgrade your account to access more features.",
      });
      return;
    }

    logger.log("kflkodo [HUpgradeButton] IS admin role, executing onClick or navigating");

    if (typeof onClick === "function") {
      onClick(event);
      return;
    }

    if (!event.defaultPrevented) {
      history.push(to);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 rounded-md text-white font-semibold shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 ${sizeClasses[size]} ${className}`}
      style={{
        backgroundImage: `linear-gradient(135deg, ${Constants.HOST_EXPERIENCE_BASE_COLOR} 0%, rgba(168, 85, 247, 1) 100%)`,
      }}
      aria-label={label}
    >
      <Sparkles className="w-4 h-4" strokeWidth={1.6} />
      <span>{label}</span>
      <Star className="w-3.5 h-3.5" fill="currentColor" stroke="currentColor" strokeWidth={1} />
    </button>
  );
};

export default HUpgradeButton;
